import React from "react";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import DeleteLink from "./DeleteLink";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { toggleMedia } from "Constants/Constants";
import * as Icons from "react-bootstrap-icons";

export default function AddedLinks({ data, idUnit, setReload, onEdit }) {
  const { t } = useTranslation();
  return (
    <div className="settings-unit-links">
      {data.length === 0 ? (
        <Translator id="noData2Display" />
      ) : (
        data.map((item, index) => {
          return (
            <div key={item.Id} className="unit-links">
              <div className="link-show">
                <small>{index + 1}</small>
                {item.TypeLink === 1 ? (
                  <img src={item.Link} alt={item.link} />
                ) : (
                  <video src={item.Link} />
                )}
              </div>
              <div className="link-links">
                <div className="link-description">
                  <div className="media-type">
                    {t(toggleMedia[item.TypeLink].key)}
                  </div>
                  <p>{item.Description}</p>
                </div>
                <div className="media-link">
                  <Icons.Link45deg size={14}/>
                  <small>
                    {item.Link}
                  </small>
                </div>
              </div>
              <div className="link-actions">
                <MuiIconButton
                  className="warning-fill"
                  icon={<Icons.Pencil />}
                  title={t("virayesh")}
                  onClick={() => onEdit(item.Id)}
                />
               <DeleteLink id={item.Id} idUnit={idUnit} setReload={setReload} />
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
